import { Map, View } from "ol"
import { fromLonLat, toLonLat, transform } from "ol/proj";
import { useEffect, useRef, useState } from "react"
import { selectTableLayer } from "../../../features/layerSlice";
import { setFitGeom, setOl3D } from "../../../features/mapSlice";
import { useAppDispatch, useAppSelector } from "../../../store/hooks";
import MapContext from "./MapContext";
import OLCesium from 'olcs/OLCesium.js';
import { SizeMe } from 'react-sizeme'
import axios from "axios";
import TurfBuffer from '@turf/buffer';
import { setSelectedFeature } from "../../../features/selectionSlice";
import { ContextMenu } from 'primereact/contextmenu';
import { setPanoGotoCoordinate } from "../../../features/panoSlice";
import { setShowPano } from '../../../features/toolbarSlice';
import { Toast } from 'primereact/toast';
import { Checkbox } from "primereact/checkbox";
import KML from "ol/format/KML";
import VectorLayer from "ol/layer/Vector";
import VectorSource from "ol/source/Vector";
import Style from "ol/style/Style";
import Stroke from "ol/style/Stroke";
import Fill from "ol/style/Fill";
import { Extent } from "ol/extent";
import { ProgressBar } from 'primereact/progressbar';
import { ExternalServicesRestApi } from "../../../utils/restapi/external-services";
import { setShowLoading } from "../../../features/sharedSlice";
import { useTranslation } from "react-i18next";
import WKT from "ol/format/WKT";
import { DrawTypes } from "../../../features/drawSlice";
import "./CustomStyle.scss"

export default function OlMap(props: any) {
  const { t } = useTranslation();
  const [map, setMap] = useState<Map>();
  const [ol3d, setOl3d] = useState<any>();
  const [carEntity, setcarEntity] = useState<any>();
  const [client, setclient] = useState<any>([0, 0]);
  const [vector, setVector] = useState<any>(null);
  const mapRef = useRef(document.createElement('div'));
  const tableLayer = useAppSelector(selectTableLayer);
  const dispatch = useAppDispatch()
  const token = useAppSelector(state => state.authState.token);
  const display3d = useAppSelector(state => state.toolbarState.show3d);
  const showPano = useAppSelector(state => state.toolbarState.showPano);
  const selectedFeature = useAppSelector(state => state.selectionState.selectedFeature);
  const panoCoordinate = useAppSelector(state => state.panoState.panoCoordinate);
  const viewAngle = useAppSelector(state => state.panoState.viewAngle);
  const importedFile = useAppSelector(state => state.import.importedFile);
  const services = useAppSelector(state => state.layer.services);
  const importedFileVisibility = useAppSelector(state => state.import.importedFileVisibility);
  const cm = useRef(null);
  const toast = useRef<any>(null);
  const [carFollowChecked, setCarFollowChecked] = useState(false)
  const [loadingBanner, setLoadingBanner] = useState<any>(false)
  const drawType = useAppSelector(state => state.drawState.drawType)
  const functionalRoles = useAppSelector(state => state.sharedState.functionalRoles);
  const mapZoom = useAppSelector(state => state.mapState.mapZoom);

  useEffect(() => {
    const view = new View({
      center: fromLonLat([35.359497, 38.980763]),
      zoom: mapZoom ? mapZoom : 7,
      minZoom: 7,
      // extent : [2732165.1390,4073787.8595,5061965.7612,5207501.8630]
    });

    const map = new Map({
      target: mapRef.current,
      view,
      layers: [],
      overlays: [],
      controls: []
    })
    const ol3d = new OLCesium({
      map
    })

    mapRef.current.addEventListener('contextmenu', (e: any) => {
      setclient([e.clientX, e.clientY])
    })

    ol3d.getCesiumScene().pickTranslucentDepth = true;

    setOl3d(ol3d);
    dispatch(setOl3D(ol3d));

    if ((window as any).Cesium !== undefined) {
      document.addEventListener(
        'touchmove',
        function (event) {
          event.preventDefault();
        },
        { passive: false }
      );
      let Cesium = (window as any).Cesium;
      const tileset = new Cesium.Cesium3DTileset({
        url: `${process.env.REACT_APP_BASE_URL}scene/aso-osb/Production_2.json`,
        maximumScreenSpaceError: 1
      })

      const tileset2 = new Cesium.Cesium3DTileset({
        url: `${process.env.REACT_APP_BASE_URL}scene/demirtas-osb/3d_mesh.json`,
        maximumScreenSpaceError: 1
      })

      const tileset3 = new Cesium.Cesium3DTileset({
        url: `${process.env.REACT_APP_BASE_URL}scene/cerkezkoy-osb/Production_1.json`,
        maximumScreenSpaceError: 1
      })

      tileset.initialTilesLoaded.addEventListener(function (e: any) {
        const heightOffset = -800;
        const boundingSphere = tileset.boundingSphere;
        const cartographic = Cesium.Cartographic.fromCartesian(boundingSphere.center);
        const surface = Cesium.Cartesian3.fromRadians(cartographic.longitude, cartographic.latitude, 0.0);
        const offset = Cesium.Cartesian3.fromRadians(cartographic.longitude, cartographic.latitude, heightOffset);
        const translation = Cesium.Cartesian3.subtract(offset, surface, new Cesium.Cartesian3());
        tileset.modelMatrix = Cesium.Matrix4.fromTranslation(translation);
      });

      tileset2.initialTilesLoaded.addEventListener(function (e: any) {
        const heightOffset = -115;
        const boundingSphere = tileset2.boundingSphere;
        const cartographic = Cesium.Cartographic.fromCartesian(boundingSphere.center);
        const surface = Cesium.Cartesian3.fromRadians(cartographic.longitude, cartographic.latitude, 0.0);
        const offset = Cesium.Cartesian3.fromRadians(cartographic.longitude, cartographic.latitude, heightOffset);
        const translation = Cesium.Cartesian3.subtract(offset, surface, new Cesium.Cartesian3());
        tileset2.modelMatrix = Cesium.Matrix4.fromTranslation(translation);
      });

      tileset3.initialTilesLoaded.addEventListener(function (e: any) {
        const heightOffset = -130;
        const boundingSphere = tileset3.boundingSphere;
        const cartographic = Cesium.Cartographic.fromCartesian(boundingSphere.center);
        const surface = Cesium.Cartesian3.fromRadians(cartographic.longitude, cartographic.latitude, 0.0);
        const offset = Cesium.Cartesian3.fromRadians(cartographic.longitude, cartographic.latitude, heightOffset);
        const translation = Cesium.Cartesian3.subtract(offset, surface, new Cesium.Cartesian3());
        tileset3.modelMatrix = Cesium.Matrix4.fromTranslation(translation);
      });

      tileset.loadProgress.addEventListener(function (numberOfPendingRequests: any, numberOfTilesProcessing: any) {
        if ((numberOfPendingRequests === 0) && (numberOfTilesProcessing === 0)) {
          setLoadingBanner(false);
          return;
        }
        setLoadingBanner(true);
      });

      tileset2.loadProgress.addEventListener(function (numberOfPendingRequests: any, numberOfTilesProcessing: any) {
        if ((numberOfPendingRequests === 0) && (numberOfTilesProcessing === 0)) {
          setLoadingBanner(false);
          return;
        }
        setLoadingBanner(true);
      });

      tileset3.loadProgress.addEventListener(function (numberOfPendingRequests: any, numberOfTilesProcessing: any) {
        if ((numberOfPendingRequests === 0) && (numberOfTilesProcessing === 0)) {
          setLoadingBanner(false);
          return;
        }
        setLoadingBanner(true);
      });

      ol3d.getCesiumScene().primitives.add(tileset);
      ol3d.getCesiumScene().primitives.add(tileset2);
      ol3d.getCesiumScene().primitives.add(tileset3);


      const position = Cesium.Cartesian3.fromDegrees(panoCoordinate[0], panoCoordinate[1], 0);

      const carEntity = new Cesium.Entity({
        position,
        model: new Cesium.ModelGraphics({
          uri: '/car.glb'
        })
      });

      setcarEntity(carEntity);
      ol3d.getDataSourceDisplay().defaultDataSource.entities.add(carEntity);
    }

    const vector = new VectorLayer({
      source: new VectorSource(),
      zIndex: 100000000,
      style: new Style({
        stroke: new Stroke({
          color: '#00000090',
          width: 2
        }),
        fill: new Fill({
          color: '#00fffe70',
        })
      })
    });
    setVector(vector)
    setMap(map);

    (window as any).map = map;


    return () => {
      map.dispose();
    }
  }, [mapRef])

  useEffect(() => {
    if (mapZoom) {
      map?.getView().setZoom(15);
    }
  }, [mapZoom])


  useEffect(() => {
    if (map) {
      setTimeout(() => {
        map.updateSize();
      }, 100);
    }
  }, [tableLayer])

  useEffect(() => {
    if (ol3d) {
      ol3d.setEnabled(display3d);
    }
  }, [display3d])

  useEffect(() => {
    if (!selectedFeature && ol3d) {
      ol3d.getDataSourceDisplay().defaultDataSource.entities.removeAll();
    }
  }, [selectedFeature])

  useEffect(() => {
    let position;
    let Cesium = (window as any).Cesium;
    position = Cesium.Cartesian3.fromDegrees(panoCoordinate[0], panoCoordinate[1], 0);
    if (carEntity) {
      carEntity.position = position;
      const newPosition = ol3d.getCesiumScene().clampToHeight(position);
      if (newPosition) {
        carEntity.position = newPosition;
      }

      if (carFollowChecked) {
        const headingRadian = Cesium.Math.toRadians(viewAngle);
        const hdr = new Cesium.HeadingPitchRange(headingRadian ? headingRadian : 0, -(Cesium.Math.PI / 12), 25);
        const boundingSphere = new Cesium.BoundingSphere(carEntity.position.getValue(), 2)
        ol3d.getCesiumScene().camera.flyToBoundingSphere(boundingSphere, { offset: hdr })
      }
    }

    if (showPano) {
      map?.getView().setCenter(transform([panoCoordinate[0], panoCoordinate[1]], 'EPSG:4326', 'EPSG:3857'));
    }

  }, [panoCoordinate])

  useEffect(() => {
    if (viewAngle) {
      let Cesium = (window as any).Cesium;
      const headingRadian = Cesium.Math.toRadians(viewAngle + 180);
      if (carEntity && carEntity.position) {
        const center = carEntity.position.getValue();
        const heading = headingRadian;
        const pitch = 0;
        const roll = 0;
        const hpr = new Cesium.HeadingPitchRoll(heading, pitch, roll);
        const quaternion = Cesium.Transforms.headingPitchRollQuaternion(center, hpr);
        carEntity.orientation = quaternion;
      }
    }
  }, [viewAngle])

  let items = [
    {
      label: 'Panoramayı Aç',
      command: (e: any) => gotoLocation(e)
    },
    {
      separator: true
    },
    {
      label: 'Koordinatı Kopyala',
      command: (e: any) => copyCoordinate(e)
    },
    {
      separator: true
    },
    display3d ? {
      label: 'Parsel Bilgisi Al',
      command: (e: any) => infoParsel(e)
    } : { className: "hidden-context-menu" },
    display3d && functionalRoles.findIndex((role: any) => role.function_id === 11) > -1 ? {
      separator: true
    } : { className: "hidden-context-menu", separator: false },
    functionalRoles.findIndex((role: any) => role.function_id === 11) > -1 ? {
      label: 'Parsel Sorgula',
      command: (e: any) => getParselFromTKGM(e)
    } : { className: "hidden-context-menu" }
  ];

  const gotoLocation = (e: any) => {
    if (!display3d) {
      const position = map?.getCoordinateFromPixel([client[0], client[1]])
      if (position) {
        const translated = toLonLat(position);
        dispatch(setPanoGotoCoordinate(translated));
        dispatch(setShowPano(true));
      }
    } else {
      let Cesium = (window as any).Cesium;
      const mousePosition = new Cesium.Cartesian2(client[0], client[1]);
      const cartesian = ol3d.getCesiumScene().pickPosition(mousePosition);
      if (cartesian) {
        const cartographic = Cesium.Cartographic.fromCartesian(cartesian);
        const longitudeString = Cesium.Math.toDegrees(cartographic.longitude);
        const latitudeString = Cesium.Math.toDegrees(cartographic.latitude);
        dispatch(setPanoGotoCoordinate([longitudeString, latitudeString]));
        dispatch(setShowPano(true));
      }
    }
  }

  const copyCoordinate = (e: any) => {
    const zart = map?.getCoordinateFromPixel([client[0], client[1]])
    if (zart) {
      const translated = toLonLat(zart);
      navigator.clipboard.writeText(translated.join(','));
      toast.current.show({ severity: 'success', detail: 'Koordinat Kopyalandı.', life: 3000 });
    }
  }

  const infoParsel = (e: any) => {
    let Cesium = (window as any).Cesium;
    const mousePosition = new Cesium.Cartesian2(client[0], client[1]);

    const cartesian = ol3d.getCesiumScene().pickPosition(mousePosition);

    if (cartesian) {
      const cartographic = Cesium.Cartographic.fromCartesian(cartesian);
      const longitudeString = Cesium.Math.toDegrees(cartographic.longitude);
      const latitudeString = Cesium.Math.toDegrees(cartographic.latitude);

      const a = [longitudeString, latitudeString]
      const offset = 0.0000000001;
      const kuzey = a[0] - offset;
      const bati = a[1] + offset;
      const guney = a[0] + offset;
      const dogu = a[1] - offset;
      const bbox = `${kuzey},${dogu},${guney},${bati}`

      const vectorService = services.find((obj: any) => obj.type === 'VECTOR')?.url
      if (vectorService) {
        let link = `${vectorService}/ows?service=WFS&version=1.0.0&request=getfeature&typeName=parsel_usr&outputFormat=application%2Fjson&bbox=${bbox},EPSG:4326` + (token ? `&token=${token}` : '');
        axios(link).then(res => {
          ol3d.getDataSourceDisplay().defaultDataSource.entities.removeAll();
          if (!res.data.features[0]) {
            return;
          }
          const f = TurfBuffer(res.data.features[0], 0.00005, { units: 'degrees' });
          dispatch(setSelectedFeature(res.data.features[0]))

          ol3d.getDataSourceDisplay().defaultDataSource.entities.add({
            polygon: {
              hierarchy: new Cesium.PolygonHierarchy(
                Cesium.Cartesian3.fromDegreesArray(f.geometry.coordinates[0].map(a => [a[0], a[1]]).flat())
              ),
              material: new Cesium.Color(0.2274, 0.8, 0.8823, 0.7),
              classificationType: Cesium.ClassificationType.BOTH,
            }
          });

        })
      } else {
        console.log('Coordinat hesaplanamadi')
      }
    } else {
      console.log('Coordinat hesaplanamadi')
    }
  }

  const getParselFromTKGM = async (e: any) => {
    try {
      const coordinate = map?.getCoordinateFromPixel([client[0], client[1]]);

      if (coordinate) {
        const translated = toLonLat(coordinate);
        dispatch(setFitGeom(null));
        dispatch(setFitGeom(null));
        dispatch(setShowLoading(true));
        const res = await ExternalServicesRestApi.getParselPoint(translated[0], translated[1], token);
        dispatch(setShowLoading(false));

        if (res && res.data) {
          if (res.data.success) {
            const geomString = res.data.result.geom;

            const wktFormat = new WKT();

            const feature :any = wktFormat.readFeature(geomString);

            const properties = res.data.result;
            delete properties['geom'];

            feature.setProperties(properties);
            feature.set('tkgm', true);
            dispatch(setSelectedFeature(feature));
          } else {
            dispatch(setShowLoading(false));
            toast.current.show({
              severity: 'error',
              summary: t('TEXT.Fail'),
              detail: t(`TEXT.${res.data.message}`),
            });
          }
        } else {
          dispatch(setShowLoading(false));
          toast.current.show({
            severity: 'error',
            summary: t('TEXT.Fail'),
            detail: t(`TEXT.Unknown Error`),
          });
        }
      }
    } catch (error) {
      dispatch(setShowLoading(false));
    }
  };

  useEffect(() => {
    if (importedFile && importedFileVisibility) {
      importedFile?.map((file: any) => {
        file.text().then((kml: any) => {

          const kmlReader = new KML()
          const features: any = kmlReader.readFeatures(kml);
          for (const feature of features) {
            feature.getGeometry()?.transform('EPSG:4326', 'EPSG:3857');
          }
          vector.getSource()?.addFeatures(features)
          map?.addLayer(vector);
          map?.getView().fit(vector.getSource()?.getExtent() as Extent, { padding: [10, 10, 10, 10] })
        });
      })
    }
    if (!importedFileVisibility) {
      map?.removeLayer(vector)
    }
  }, [importedFile, importedFileVisibility])

  useEffect(() => {
    if (importedFile) {
      toast.current.show({ severity: 'success', summary: 'Success', detail: 'Kml Uploaded Successfully' });
    }

  }, [importedFile])

  return (
    <>
      {loadingBanner && <div className="loading-banner">
        <div style={{ marginBottom: '2px' }}>Yükleniyor...</div>
        <ProgressBar style={{ height: '3px' }} mode="indeterminate" />
      </div>}
      <Toast ref={toast} />
      <ContextMenu model={items} ref={cm}></ContextMenu>
      <SizeMe>{() => { map?.updateSize(); return <div style={{ width: '100%', height: '100%', position: 'absolute' }}></div> }}</SizeMe>
      <div onContextMenu={(e) => drawType && drawType !== DrawTypes.POINT && drawType !== DrawTypes.LINESTRING && drawType !== DrawTypes.POLYGON && (cm as any).current.show(e)} className='map-div' ref={mapRef}></div>
      {showPano && display3d && <div style={{
        position: 'absolute', right: '470px', bottom: '9px', backgroundColor: 'var(--surface-a)', padding: '7px', borderRadius: '3px',
        border: '2px solid var(--primary-color)'
      }}>
        <Checkbox style={{ marginRight: '5px' }} onChange={e => setCarFollowChecked(e.checked)} checked={carFollowChecked}></Checkbox>
        <label style={{ userSelect: 'none' }}>Aracı Takip Et</label>
      </div>}
      {
        map &&
        <MapContext.Provider value={map}>
          {props.children}
        </MapContext.Provider>
      }
    </>
  )
}
